import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import System from './system-model'
import {
  CreateSystemAsync,
  DeleteSystemAsync,
  LoadSystemsAsync,
} from './system-thunk'
const initialState: systemSliceState = {
  system: [],
  selected_system: '',
  is_loading_system: false,
  is_creating_system: false,
  is_deleting_system: false,
}
export interface systemSliceState {
  system: System[]
  selected_system?: string
  is_loading_system: boolean
  is_creating_system: boolean
  is_deleting_system: boolean
}
export const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setSelectedsystem: (state, action) => {
      state.selected_system = action.payload
    },
    clearStatesystem: (state) => {
      state.system = []
      state.is_loading_system = false
      state.is_creating_system = false
      state.is_deleting_system = false
    },
    mergesystem: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_system = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.system = merge(state.system, payload) as any
        }
      }
    },

    add_system: (state, action) => {
      if (action.payload) {
        state.system = [...state.system, action.payload]
      }
    },
    set_system: (state, action) => {
      let { key, value, id } = action.payload
      state.system = state.system.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSystemsAsync.pending, (state) => {
      state.is_loading_system = true
    })
    builder.addCase(LoadSystemsAsync.fulfilled, (state, action) => {
      state.is_loading_system = false
      if (action.payload) {
        state.system = action.payload
      }
    })
    builder.addCase(LoadSystemsAsync.rejected, (state) => {
      state.is_loading_system = false
    })
    builder.addCase(CreateSystemAsync.pending, (state) => {
      state.is_creating_system = true
    })
    builder.addCase(CreateSystemAsync.fulfilled, (state) => {
      state.is_creating_system = false
    })
    builder.addCase(CreateSystemAsync.rejected, (state) => {
      state.is_creating_system = false
    })
    builder.addCase(DeleteSystemAsync.pending, (state) => {
      state.is_deleting_system = true
    })
    builder.addCase(DeleteSystemAsync.fulfilled, (state, action) => {
      state.is_deleting_system = false
      if (state.system) {
        state.system = state.system.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteSystemAsync.rejected, (state) => {
      state.is_deleting_system = false
    })
  },
})

export const {
  clearStatesystem,
  setSelectedsystem,
  set_system,
  mergesystem,
  add_system,
} = systemSlice.actions

export const get_system =
  (id?: string) =>
  (state: {
    system: {
      system: System[]
    }
  }): System | null => {
    let temp = state?.system?.system?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.system?.system[0] || null
  }
export const get_selected_system = (state: {
  system: systemSliceState
}): System | null => {
  let id = state?.system?.selected_system
  let temp = state?.system?.system?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_system = (state: {
  system: {
    system: System[]
  }
}): System[] => {
  let temp = state?.system?.system
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_system_busy = (state: { system: systemSliceState }) => {
  return (
    state?.system.is_deleting_system ||
    state?.system.is_loading_system ||
    state?.system.is_creating_system
  )
}
export const is_deleting_system_busy = (state: {
  system: systemSliceState
}) => {
  return state?.system.is_deleting_system
}
export const is_loading_system_busy = (state: { system: systemSliceState }) => {
  return state?.system.is_loading_system
}
export const is_creating_system_busy = (state: {
  system: systemSliceState
}) => {
  return state?.system.is_creating_system
}

export default systemSlice.reducer
